import { useEffect } from "react"

const upsertMeta = (selector, attributes) => {
  let element = document.head.querySelector(selector)
  if (!element) {
    element = document.createElement("meta")
    document.head.appendChild(element)
  }

  Object.entries(attributes).forEach(([name, value]) => {
    element.setAttribute(name, value)
  })
}

export default function MarketingSeo({ title, description, path = "/" }) {
  useEffect(() => {
    const canonicalUrl = `https://jarbod.com${path === "/" ? "" : path}`
    const socialImage = "https://jarbod.com/og.png"

    document.title = title
    upsertMeta('meta[name="description"]', { name: "description", content: description })
    upsertMeta('meta[property="og:title"]', { property: "og:title", content: title })
    upsertMeta('meta[property="og:description"]', {
      property: "og:description",
      content: description,
    })
    upsertMeta('meta[property="og:type"]', { property: "og:type", content: "website" })
    upsertMeta('meta[property="og:url"]', { property: "og:url", content: canonicalUrl })
    upsertMeta('meta[property="og:image"]', { property: "og:image", content: socialImage })
    upsertMeta('meta[name="twitter:card"]', {
      name: "twitter:card",
      content: "summary_large_image",
    })
    upsertMeta('meta[name="twitter:title"]', { name: "twitter:title", content: title })
    upsertMeta('meta[name="twitter:description"]', {
      name: "twitter:description",
      content: description,
    })
    upsertMeta('meta[name="twitter:image"]', {
      name: "twitter:image",
      content: socialImage,
    })

    let canonical = document.head.querySelector('link[rel="canonical"]')
    if (!canonical) {
      canonical = document.createElement("link")
      canonical.setAttribute("rel", "canonical")
      document.head.appendChild(canonical)
    }
    canonical.setAttribute("href", canonicalUrl)
  }, [description, path, title])

  return null
}

